import React from 'react';
import {Time, IMessage, TimeProps} from 'react-native-gifted-chat';

export default function ChatTime(props: TimeProps<IMessage>) {
  return <Time {...props} position="left" timeFormat="HH:mm" />;
}
